import React from 'react'
import {Col, Row} from "react-bootstrap";

import BizLocationSelector from "../../component/BizLocation/BizLocationSelector";
import Caption from "../../component/Caption/Caption";
import { DateRangeSelector } from '../../component/Date/DateRangeSelector';

export const StockLevelHeader = ({setBizLocation, setStartDate, setEndDate, defaultStartDate, defaultEndDate}) => {

  return (
      <Row className="d-flex align-items-center">
        <Col sm={4}>
          <BizLocationSelector onChange={setBizLocation}/>
        </Col>
        <Col sm={2}>
          <DateRangeSelector
            onChange={(endDate, startDate) => {
              setStartDate(startDate)
              setEndDate(endDate)
            }}
            defaultEndDate={defaultStartDate}
            defaultStartDate={defaultEndDate}
          />
        </Col>
        <Col sm={4} className="mt-4">
          <Caption captionLevels={['>130%', '>120%', '100%', '<90%', '<80%', '<65%']}/>
        </Col>
      </Row>
  )
}



// WEBPACK FOOTER //
// ./src/pages/StockLevel/StockLevelHeader.js